import { Component } from 'preact';
import { subscribeRulesLanguage } from './preferences';

// Re-renders the whole tree when the language preference changes so every
// t() call picks up the new language without per-component subscriptions.
// It renders through a function and passes a version that changes on every
// switch: Preact skips any subtree whose vnode is the same object as last
// time (a component that passes `children` through does exactly that), so
// the subtree must be rebuilt from fresh vnodes with a changed prop, not
// merely re-rendered.
export default class LanguageRoot extends Component {
  state = { version: 0 };
  componentDidMount() { this.unsubscribe = subscribeRulesLanguage(() => this.setState((s) => ({ version: s.version + 1 }))); }
  componentWillUnmount() { this.unsubscribe?.(); }
  render({ render }, { version }) { return render(version); }
}
